module.exports = __webpack_public_path__ + "static/flags/TP-515c51873dd7a57cec5378105d7b9a3c.gif";